import { HttpClient } from '../../httpClient'
import type {
  OpalApi,
  OpalApiResponseDocument,
  OpalApiRequestBody,
} from '../../schema'

type CreateMomentV3 = OpalApi<'CreateMomentV3', 201>

export type CreateMomentV3ResponseData = OpalApiResponseDocument<
  'CreateMomentV3',
  201
>

export type CreateMomentV3RequestBody = OpalApiRequestBody<'CreateMomentV3'>

export const createMoment: CreateMomentV3 = async ({
  requestBody,
}: Parameters<CreateMomentV3>[0] = {}) => {
  return HttpClient()
    .post<CreateMomentV3ResponseData>('/moments/v3', requestBody)
    .then((res) => res.data)
}
